import React, { FC } from 'react';
import styled from 'styled-components';
import ProgressRing from '@adsk/alloy-react-progress-ring';

const ProjectLoaderContainer = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

const ProjectsLoader: FC = () => (
  <ProjectLoaderContainer>
    <ProgressRing
      data-testid="ProjectsLoader"
      size={ProgressRing.SIZES.LARGE}
    />
  </ProjectLoaderContainer>
);

export default ProjectsLoader;
